import Cookies from 'utils/Cookies';

const SOT_TRACKING_ID_COOKIE = 'sti';

// The SOT (Sephora One Tag) library persists its tracking id in the 'sti' cookie
// (the same value SOT sends as session.sotTrackingId). It tracks both registered
// and anonymous GenAI clients, so it is sent as sot_tracking_id on GenAI requests.
// Returns '' when unavailable (SSR or cookie not yet set).
const getSotTrackingId = () => {
    try {
        return Cookies.read(SOT_TRACKING_ID_COOKIE) || '';
    } catch (e) {
        Sephora?.logger?.verbose(`SuperChat: failed to read the "${SOT_TRACKING_ID_COOKIE}" (sot_tracking_id) cookie:`, e);

        return '';
    }
};

const SOT_TRACKING_ID_HEADER = 'sot-tracking-id';

// GAI-7186: the genAI-PA services read sot_tracking_id from the 'sot-tracking-id'
// request header. The header is set only when the cookie has a value so the
// backend's optional-header default (None) applies instead of an empty string.
// Returns the value so callers can reuse it in body/query params.
const appendSotTrackingIdHeader = headers => {
    const sotTrackingId = getSotTrackingId();

    if (sotTrackingId) {
        headers[SOT_TRACKING_ID_HEADER] = sotTrackingId;
    }

    return sotTrackingId;
};

export {
    SOT_TRACKING_ID_COOKIE, SOT_TRACKING_ID_HEADER, appendSotTrackingIdHeader
};

export default getSotTrackingId;
